// Päiväkirjan haku ja suodattimet (suunnitelman kohta 11.4). Puhdas funktio,
// jotta suodatus on helppo testata ilman käyttöliittymää.

const DAY = 86_400;

/**
 * filters: { text, mode, period: "all" | "30d" | "year", confirmedOnly }
 * Teksti etsii retken nimestä, muistiinpanosta sekä kohteiden ja reittien
 * nimistä. Isot ja pienet kirjaimet sekä ääkkösten diakriitit eivät erottele.
 */
export function filterTrips(trips, filters, now = Date.now() / 1000) {
  const needle = normalize(filters.text ?? "");
  const thisYear = new Date(now * 1000).getFullYear();
  return trips.filter((t) => {
    if (filters.mode && !t.modes.includes(filters.mode)) return false;
    if (filters.period === "30d" && t.started_at < now - 30 * DAY) return false;
    if (filters.period === "year" && new Date(t.started_at * 1000).getFullYear() !== thisYear) return false;
    if (filters.confirmedOnly && !t.has_confirmations) return false;
    if (needle) {
      const haystack = normalize([t.name, t.note ?? "", ...(t.places ?? [])].join(" "));
      if (!haystack.includes(needle)) return false;
    }
    return true;
  });
}

function normalize(s) {
  return s.toLocaleLowerCase("fi-FI").normalize("NFD").replace(/[̀-ͯ]/g, "").trim();
}
